/// <amd-module name="Analytics/Boards/BurndownQueries/ProjectsIterationsByIdQuery" />
import { Iteration, ODataIteration } from "Analytics/Boards/BoardsQueries/IterationsQuery";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import * as PublicProjectsQueryHelper from "Analytics/Common/Utilities/PublicProjectsQueryHelper";
import { QueryUtilities } from "Analytics/Common/Utilities/QueryUtilities";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { IVssPageContext } from "VSS/Platform/Context";
import { uniqueSort } from "VSS/Platform/Util/Array";
import { BurndownQueryBase } from "./BurndownQueryBase";

/**
 * Gets iteration details for specified iteration IDs
 */
export class ProjectsIterationsByIdQuery extends BurndownQueryBase<Iteration[]> {
    private static generateQueryOptions(pageContext: IVssPageContext, projectIDs: string[], iterationIDs: string[]): ODataQueryOptions {
        const projectClause = QueryUtilities.isInArray("ProjectSK", uniqueSort(projectIDs));
        const iterationsClause = QueryUtilities.isInArray("IterationSK", iterationIDs);
        const $filter = `(${projectClause}) and (${iterationsClause})`;

        const $orderby = `IsEnded,StartDate desc,EndDate desc,IterationName`;

        const $select = `IterationSK,IterationName,StartDate,EndDate,IsEnded`;

        return PublicProjectsQueryHelper.forceProjectScoping(pageContext, projectIDs, {
            entityType: "Iterations",
            oDataVersion: latestODataVersion,
            $filter: $filter,
            $orderby: $orderby,
            $select: $select
        });
    }
    constructor(pageContext: IVssPageContext, projectIDs: string[], iterationIDs: string[], commandName?: string) {
        super(ProjectsIterationsByIdQuery.generateQueryOptions(pageContext, projectIDs, iterationIDs), commandName);
    }

    public getQueryName(): string {
        return "ProjectsIterationsByIdQuery";
    }

    /**  Override default behavior, by reversing results  */
    protected interpretQueryResults(data: { value: ODataIteration[] }): Iteration[] {
        return data.value
            .map(odataIteration => {
                return {
                    IterationSK: odataIteration.IterationSK,
                    IterationName: odataIteration.IterationName,
                    IterationPath: odataIteration.IterationPath,
                    StartDateTimeOffset: odataIteration.StartDate,
                    EndDateTimeOffset: odataIteration.EndDate,
                    IsEnded: odataIteration.IsEnded
                };
            })
            .reverse();
    }
}
